export default {
  data() {
    return {
      windowSize: window.innerWidth,
      windowHeight: window.innerHeight,
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.windowSize = window.innerWidth
    })
  },
  onResize() {
    this.windowSize = window.innerWidth
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize)
  },
}
